import React from 'react';
import styled from 'styled-components';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewToggleButtonBody(props) {
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	const mainBodyKey = `form-body-${body.id}-toggle`;

	return (
		<StyledPrintViewToggleButtonBody key={mainBodyKey} className={`StyledPrintViewToggleButtonBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewToggleButtonBodyData" id={body.id}>
				{body.optionsAndResponses.map((data) => {
					return (
						<button
							key={`${mainBodyKey}-toggle-option-${data.bodyOptionId}`}
							name={data.id}
							title={data.bodyOptionText}
							id={data.bodyOptionId}
							type="button"
							className={`toggleButton ${data.bodySelectedOptionId === 1 ? 'selected-option' : ''}`}
							disabled
						>
							{data.bodyOptionText}
						</button>
					);
				})}
			</section>
		</StyledPrintViewToggleButtonBody>
	);
}

const StyledPrintViewToggleButtonBody = styled.section`
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
	.selected-option {
		font-weight: bold;
		background-color: var(--neutrals-300) !important;
	}
	button {
		max-width: 50%;
		text-align: center;
	}
`;

export default PrintViewToggleButtonBody;
